import { EClientType } from 'types/Company';
import { DocumentUtils, cleanDocument } from './documentUtils';

export function validateCnpj(value: string) {
	return DocumentUtils.isCnpjValid(value);
}

export function validateCpf(value: string) {
	if (typeof value !== 'string') {
		return false;
	}

	value = value.replace(/[^\d]+/g, '');

	if (
		value.length !== 11 ||
		!!value.match(/(\d)\1{10}/) ||
		value === '00000000000' ||
		value === '11111111111' ||
		value === '22222222222' ||
		value === '33333333333' ||
		value === '44444444444' ||
		value === '55555555555' ||
		value === '66666666666' ||
		value === '77777777777' ||
		value === '88888888888' ||
		value === '99999999999'
	) {
		return false;
	}

	const values = value.split('').map(el => +el);
	const rest = (count: number) =>
		((values
			.slice(0, count - 12)
			.reduce((soma, el, index) => soma + el * (count - index), 0) *
			10) %
			11) %
		10;

	return rest(10) === values[9] && rest(11) === values[10];
}

export const validateEmail = (value: string): boolean => {
	const emailRegex = new RegExp(
		/^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/,
		'gm',
	);
	return emailRegex.test(value);
};

export const validateJson = (value: string): boolean => {
	try {
		JSON.parse(value);
	} catch (e) {
		return false;
	}
	return true;
};

export const isPersonOrCompany = (taxId?: string) => {
	const clean = cleanDocument(taxId);

	if (clean.length === 11) {
		return EClientType.PF;
	}

	if (clean.length === 14) {
		return EClientType.PJ;
	}
};

// Dicionário Português-BAAS
export const fixPhraseFromBaas = (phrase: string): string => {
	const fixes: { [key: string]: string } = {
		cobrana: 'cobrança',
		Cobrana: 'Cobrança',
		depsito: 'depósito',
		Depsito: 'Depósito',
		manuteno: 'manutenção',
		Manuteno: 'Manutenção',
		undefined: '-',
		Undefined: '-',
		Emisso: 'Emissão',
		emisso: 'emissão',
	};

	let correctPhrase = phrase;
	for (const [wrong, right] of Object.entries(fixes)) {
		const regex = new RegExp(wrong, 'g');
		correctPhrase = correctPhrase.replace(regex, right);
	}

	return correctPhrase;
};
